// Normaliza os campos de rede social da loja em URLs clicaveis.
// O lojista digita das tres formas ("@loja", "loja", "https://instagram.com/loja"),
// entao aceitar so URL completa deixaria metade dos cadastros sem link.

const REDES = [
  { key: "instagram", label: "Instagram", prefixo: "https://instagram.com/" },
  { key: "facebook", label: "Facebook", prefixo: "https://facebook.com/" },
  { key: "tiktok", label: "TikTok", prefixo: "https://tiktok.com/@" },
  { key: "kwai", label: "Kwai", prefixo: "https://kwai.com/@" },
];

function normalizar(raw, prefixo) {
  const s = String(raw || "").trim();
  if (!s) return "";
  if (s.startsWith("http://") || s.startsWith("https://")) return s;
  return `${prefixo}${s.replace(/^@/, "")}`;
}

/** [{ key, label, url }] apenas das redes preenchidas, + WhatsApp quando ha telefone.
 *  Fora do cabecalho desde 25/08/2026 (decisao do dono) — as redes seguem no
 *  modal "Informacoes da Loja". Mantido aqui porque e' de onde o modal lê. */
export function buildSocialLinks(companySettings) {
  const links = REDES
    .map(({ key, label, prefixo }) => ({
      key,
      label,
      url: normalizar(companySettings?.[key], prefixo),
    }))
    .filter((l) => l.url);

  const digits = String(companySettings?.phone || "").replace(/\D/g, "");
  if (digits.length >= 10) {
    links.push({ key: "whatsapp", label: "WhatsApp", url: `https://wa.me/55${digits}` });
  }
  return links;
}

/** Link do Google Maps pro endereco da loja ("" quando nao ha endereco). */
export function buildMapsUrl(address) {
  const s = String(address || "").trim();
  return s ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(s)}` : "";
}
